<template>
    <div class="page">
      <!-- 搜索 -->
      <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
        <el-form-item label="原手机号">
          <el-input 
            style="width: 200px" 
            v-model="queryForm.oldPhone" 
            placeholder="请输入原手机号"
            maxlength="11"
          >
            <span slot="suffix" class="phone-count">{{ queryOldPhoneLength }}/11</span>
          </el-input>
        </el-form-item>
        <el-form-item label="新手机号">
          <el-input 
            style="width: 200px" 
            v-model="queryForm.newPhone" 
            placeholder="请输入新手机号"
            maxlength="11"
          >
            <span slot="suffix" class="phone-count">{{ queryNewPhoneLength }}/11</span>
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search" @click="getAbnormalUserList">查询</el-button>
          <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
        </el-form-item>
      </el-form>
  
      <div class="page-content">
        <div class="page-tool-bar">
            <div class="el-btn-group">
                <el-button
                    type="primary"
                    plain
                    size="small"
                    icon="el-icon-link"
                    @click="transferAssets"
                >资产转移</el-button>
            </div>
          <div class="icon-group">
            <span
              title="搜索"
              class="icon-box"
              @click="search"
            >
              <Icon color="#606266">
                <Search />
              </Icon>
            </span>
            <span
              class="icon-box"
              @click="refreshAbnormalUserList"
            >
              <Icon color="#606266">
                <Refresh />
              </Icon>
            </span>
          </div>
        </div>
        <!-- 列表数据 -->
        <el-table
          :data="abnormalUserList"
          row-key="id"
          border
          height="100%"
          :header-row-style="{height: '10px'}"
          :header-cell-style="{padding: '10px'}"
          :row-style="{height: '9px'}"
          :cell-style="{padding: '9px'}"
          size="small"
          v-loading="loading"
        >
          <el-table-column width="180" :show-overflow-tooltip="true" align="center" prop="oldPhone" label="原手机号"/>
          <el-table-column width="180" :show-overflow-tooltip="true" align="center" prop="newPhone" label="新手机号" />
          <el-table-column width="180" :show-overflow-tooltip="true" align="center" prop="createUserPhone" label="操作人手机号" />
          <el-table-column width="180" :show-overflow-tooltip="true" align="center" prop="createTime" label="操作时间" />
          <el-table-column :show-overflow-tooltip="true" align="center" prop="transferContent" label="转移内容" />
        </el-table>
        <div class="pagination-box">
          <el-pagination
            @size-change="sizeChange"
            @current-change="currentChange"
            :current-page.sync="currentPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalNum"
            background
            :pager-count="7"
          >
          </el-pagination>
        </div>
      </div>

       <!-- 资产转移弹框 -->
       <el-dialog title="资产转移" :visible.sync="transferDialogVisible" width="30%" @close="closeTransferDialog">
            <div>
                <el-form :model="transferForm" ref="transferForm" :rules="transferRules" label-width="100px" size="small">
                    <el-form-item label="原手机号" prop="oldPhone">
                        <el-input
                            v-model="transferForm.oldPhone"
                            placeholder="请输入原手机号"
                            style="width: 200px"
                            maxlength="11"
                        >
                            <span slot="suffix" class="phone-count">{{ oldPhoneLength }}/11</span>
                        </el-input>
                    </el-form-item>
                    <el-form-item label="新手机号" prop="newPhone">
                        <el-input
                            v-model="transferForm.newPhone"
                            placeholder="请输入新手机号"
                            style="width: 200px"
                            maxlength="11"
                        >
                            <span slot="suffix" class="phone-count">{{ newPhoneLength }}/11</span>
                        </el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div slot="footer" class="flex justify-end">
                <el-button @click="closeTransferDialog">取消</el-button>
                <el-button type="primary" @click="submitTransfer">确定</el-button>
            </div>
        </el-dialog>
            
    </div>
  </template>
  
<script>
import { Refresh, Search } from '@v2icons/tabler';
import { get, postJson } from '@/utils/request.js';
  
export default {
    components: {
      Refresh,
      Search
    },
    data() {
      return {
        queryForm: {
            oldPhone: '', // 原手机号
            newPhone: '' // 新手机号
        },
        loading: false,
        isSearch: false,
        pageSize: 10,
        currentPage: 1,
        totalNum: 0,
        abnormalUserList: [],
        transferDialogVisible: false,
        transferForm: {
            oldPhone: '',
            newPhone: ''
        },
        transferRules: {
            oldPhone: [
                { required: true, message: '请输入原手机号', trigger: 'blur' },
                { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号', trigger: 'blur' }
            ],
            newPhone: [
                { required: true, message: '请输入新手机号', trigger: 'blur' },
                { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号', trigger: 'blur' }
            ]
        }
      };
    },
    computed:{
        oldPhoneLength() {
            return this.transferForm.oldPhone ? this.transferForm.oldPhone.length : 0;
        },
        newPhoneLength() {
            return this.transferForm.newPhone ? this.transferForm.newPhone.length : 0;
        },
        queryOldPhoneLength() {
            return this.queryForm.oldPhone ? this.queryForm.oldPhone.length : 0;
        },
        queryNewPhoneLength() {
            return this.queryForm.newPhone ? this.queryForm.newPhone.length : 0;
        }
    },
    created() {
      this.getAbnormalUserList();
    },
    methods: {
         // 资产转移
         transferAssets() {
            this.transferDialogVisible = true;
            this.transferForm = {
                oldPhone: '',
                newPhone: ''
            };
        },
        // 关闭资产转移弹框
        closeTransferDialog() {
            this.transferDialogVisible = false;
            this.transferForm = {
                oldPhone: '',
                newPhone: ''
            };
            if (this.$refs.transferForm) {
                this.$refs.transferForm.resetFields();
            }
        },
        // 提交资产转移
        submitTransfer() {
            this.$refs.transferForm.validate((valid) => {
                if (valid) {
                    postJson('/dataTransfer/zj', {
                        oldPhone: this.transferForm.oldPhone,
                        newPhone: this.transferForm.newPhone
                    }).then((res) => {
                        if (res.success || res.code == 200) {
                            this.$message({
                                message: res.msg,
                                type: 'success',
                                duration: 2000
                            });
                            this.closeTransferDialog();
                            this.getAbnormalUserList();
                        } else {
                            this.$message({
                                message: res.msg || res.message || '资产转移失败',
                                type: 'error',
                                duration: 2000
                            });
                        }
                    }).catch((err) => {
                        this.$message({
                            message: err.response?.data?.msg || err.response?.data?.message || '资产转移失败',
                            type: 'error',
                            duration: 2000
                        });
                    });
                }
            });
        },
        // 搜索box
        search() {
            this.isSearch = !this.isSearch;
        },
        resetAbnormalUserList() {
            this.pageSize = 10;
            this.currentPage = 1;
            this.abnormalUserList = [];
        },
        resetDialog() {
            this.queryForm.oldPhone = '';
            this.queryForm.newPhone = '';
            this.getAbnormalUserList();
        },
        refreshAbnormalUserList() {
            this.resetAbnormalUserList();
            this.getAbnormalUserList();
        },
        // 获取列表信息
        getAbnormalUserList() {
            this.loading = true;
            get(`/dataTransfer/list`, {
                ...this.queryForm,
                pageNum: this.currentPage,
                pageSize: this.pageSize
            }).then((res) => {
                this.loading = false;
                if (res.success) {
                    this.abnormalUserList = res.list.list;
                    this.totalNum = res.list.total;
                } else {
                    this.$message({
                    message: res.msg,
                    type: 'error',
                    duration: 2000
                    });
                }
            });
        },
        currentChange(page) {
            this.currentPage = page;
            this.getAbnormalUserList();
        },
        sizeChange(size) {
            this.pageSize = size;
            this.getAbnormalUserList();
        },
    }
};
</script>
  
<style lang="scss" scoped>
.count {
    font-size: 14px;
    margin-left: 10px;
    padding: 0 4px;
}
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
    padding: 15px 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    button {
        display: flex;
        align-items: center;
        justify-content: center;
    }
}
.phone-count {
    font-size: 12px;
    color: #409eff;
    padding-right: 10px;
}
</style>
  
  